import React from 'react';
import {createRoot} from 'react-dom/client';
import {type AlertButton} from 'react-native';

type AlertComponentProps = {
  message?: string;
  titleText?: string;
  buttons?: AlertButton[];
  onClose: (confirmed?: boolean) => void;
};

// TODO: Add support for game themes
export const CustomAlertComponent = (props: AlertComponentProps) => {
  const {message, titleText, buttons, onClose} = props;
  const messageDisplay = message || "Uh oh! Doesn't look like that worked. Please try again";
  const customButtons = buttons?.filter((b) => b.text)?.slice(0, 2);
  const defaultButton = [
    {
      text: 'OK',
      onPress: onClose,
    },
  ];
  const alertButtons = customButtons?.length ? customButtons : defaultButton;

  return (
    <div
      className='fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center'
      style={{
        // Because federated login ui is 9999
        zIndex: 10000,
      }}
    >
      <div
        className='bg-white rounded-lg shadow-lg max-w-sm w-full p-4'
        onClick={(e) => e.stopPropagation()}
      >
        {titleText && <h2 className='text-xl font-bold text-center mb-4'>{titleText}</h2>}
        <p className='mb-4 font-semibold text-center whitespace-break-spaces'>{messageDisplay}</p>
        <div className='flex justify-center space-x-2'>
          {alertButtons.map((button, index) => (
            <button
              key={index}
              className='flex-1 bg-gradient-to-b from-[#1f8ed4] to-[#5ebffd] text-white font-bold py-2 px-4 rounded'
              onClick={async () => {
                const result = button.onPress?.();
                if (result instanceof Promise) {
                  result.then((e) => {
                    onClose(e);
                  });
                } else {
                  onClose();
                }
              }}
            >
              {button.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export const customAlert = (
  title: string,
  message?: string,
  buttons?: AlertButton[]
): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleClose = (confirmed?: boolean) => {
      root.unmount();
      container.remove();
      resolve(!!confirmed);
    };

    root.render(
      <CustomAlertComponent
        titleText={title}
        message={message}
        buttons={buttons}
        onClose={handleClose}
      />
    );
  });
};
